import { Link, Typography } from "@mui/material";
import { Links } from "src/constants";
import { FeedItemDto, FeedItemUserValueDto } from "src/http";

interface Props {
  feedItem: FeedItemDto;
}

const DecisionMakerPropertyChange = (props: Props) => {
  const value = props.feedItem.propertyChange!.value as FeedItemUserValueDto | null;

  if (value != null) {
    return (
      <Typography variant="caption">
        <Link href={Links.User(props.feedItem.user.userId)}>{props.feedItem.user.displayName}</Link>
        <span> assigned </span>
        <strong>
          <Link href={Links.User(value.userId)}>{value.displayName}</Link>
        </strong>
        <span> as the decision maker</span>
      </Typography>
    );
  }

  return (
    <Typography variant="caption">
      <Link href={Links.User(props.feedItem.user.userId)}>{props.feedItem.user.displayName}</Link>
      <span> unassigned the decision maker</span>
    </Typography>
  );
};

export { DecisionMakerPropertyChange };
